import React from 'react'
import Colorpicker from '../Colorpicker/Colorpicker'

export default class Key extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <div className="chart-key col-sm-2" style={{marginTop:`${this.props.dimensions().margin.top}px`}}>
        {this.renderKeyDetails()}
      </div>
    );
  };

  renderKeyDetails(){
    var listItems = this.props.dataDetails.map((detail, idx) => {
      return(
        <li key={detail.display_name + idx}>
          {<Colorpicker name={detail.display_name} color={detail.color} read_only={true} width={12} height={12} />}  <p style={{ 'display': 'inline-block', marginRight: '20px' }}>{detail.data_source.system_data && !detail.segment_ids ?  detail.display_name : detail.display_name}</p>
        </li>
      )
    });

    return (
      <div >
        <ul style={{ listStyleType: 'none', paddingLeft: '0px' }}>
          {listItems}
        </ul>
      </div>
    );
  };

  getUniqueSourceDetails(yDetails) {
    return Array.from(new Set(yDetails.map(detail => detail.source_detail.id))).map(sourceId => yDetails.find(detail => detail.source_detail.id === sourceId).source_detail);
  };

};